import {UserIcon} from "@pg-design/icons-module";

export const NavigationUserIcon = () => {
    return <UserIcon size="1.6" wrapperColor="var(--colors-beige-subtle)" wrapperSize="3.6" wrapperType="circle" />;
};
import {UserIcon} from "@pg-design/icons-module";

export const NavigationUserIcon = () => {
    return <UserIcon size="1.6" wrapperColor="var(--colors-beige-subtle)" wrapperSize="3.6" wrapperType="circle" />;
};
